import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../store/auth/selector";
import { LoginScreen } from "../screen/login"
import { getAppInfo, getGateConf } from "../store/app/selector";
import * as appActions from "../store/app/actions"
import { useEffect } from "react";


export const SecureScreen = (props) => {
    const dispath = useDispatch()
    const gateConfig = useSelector(state => getGateConf(state))

    const { component } = props
    const appInfo = useSelector(state => getAppInfo(state))
    const userData = useSelector(state => getUserData(state, appInfo));


    useEffect(() => {
        if (appInfo) {
            dispath(appActions.getGateConfig(appInfo.gate))
        }
    }, [appInfo])

    return (
        <>
            {
                gateConfig &&
                    userData ? <>{ component }</> : <LoginScreen />
            }
        </>
    )
}